import React, { useMemo, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
// import { ArrowRightOutlined } from "@ant-design/icons";
import arrowright from "../../assets/arrowright.svg";
import Vectorsorting from "../../assets/Vectorsorting.svg";
// import { Image } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ShimmerLoader from "../../loading";
import CustomPagination from "../CustomWidgets/CustomPagination";

const TransactionSummaryTable = ({ tabledata, pagination }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [flag, setflag] = useState(false);
  // const is_lahloob = useSelector(
  //   (state) => state.login?.user?.result?.is_lahloob
  // );

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const data = tabledata;

  useEffect(() => {
    if (tabledata?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [data, flag]);

  const openOrderList = (orderNumber) => {
    navigate(`/Orderlist?orderDetail=${orderNumber}`);
  };


  const formatSessionState = state => {
    if (!state) return '';

    return state
      .split('_') // Split by underscore
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with a space
  };

  const columns = useMemo(() => {
    const baseColumns = [
      ...(allStores
        ? [
          {
            Header: (t("Store Name")),
            accessor: "store_name",
            Cell: ({ value }) => (
              <button
                // className="text-[#1b4497] rounded-lg"
                // onClick={() => openOrderList(value)}
              >
                {value || "--"}
              </button>
            ),
          },
        ]
        : []),
      { Header: (t("Order Date Time")), accessor: "order_date" },
      {
        Header: (t("Sale Order Number")),
        accessor: "sale_order_number",
        Cell: ({ value }) => (
          <button
            className="text-[#1b4497] rounded-lg"
            onClick={() => openOrderList(value)}
          >
            {value || "N/A"}
          </button>
        ),
      },
      // { Header: (t("Status")), accessor: "status",Cell: ({ value }) => value  },
      // { Header: (t("Retailer Name")), accessor: "retailer_name",Cell: ({ value }) => value  },
      // { Header: (t("Retailer Location")), accessor: "retailer_location",Cell: ({ value }) => value  },
      // { Header: (t("Retailer Number")), accessor: "retailer_number",Cell: ({ value }) => value  },
      // { Header: (t("Shop Type")), accessor: "shop_type",Cell: ({ value }) => value  },
      { Header: (t("Item Total")), accessor: "item_total", Cell: ({ value }) => `EGP ${value.toFixed(2)}` },
      // { Header: (t("MGI Percentage")), accessor: "mgi_percentage" , Cell: ({ value }) => `${value.toFixed(2)}%`,},
      { Header: (t("myGINNE Commision")), accessor: "mgi_commission_new", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("myGINNE Platform Fee")), accessor: "mgi_platform_fee", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("myGINNE Delivery Fee")), accessor: "mgi_delivery_fee", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("myGINNE Discount")), accessor: "mge_discount", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("Total Order Value")), accessor: "total_order_value", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("Online Collection Charges")), accessor: "online_collection_charges", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("Online Transaction Fees")), accessor: "online_transaction_fees", Cell: ({ value }) => `EGP  ${value.toFixed(2)}`, },
      { Header: (t("Amount Collected Online")), accessor: "amount_collected_online", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      // { Header: (t("Net Amount to Retailer(Do not use)")), accessor: "net_amount_to_retailer" , Cell: ({ value }) => `EGP ${value.toFixed(2)}`,},
      { Header: (t("Amount collected by Store")), accessor: "amount_collected_by_retailer", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("Net Amount")), accessor: "net_amount", Cell: ({ value }) => `EGP ${value.toFixed(2)}`, },
      { Header: (t("Status")), accessor: "payment_status", Cell: ({ value }) => t(formatSessionState(value)) },

    ];

    return baseColumns;
  }, [data,]);



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 20 },
    },
    useSortBy,
    usePagination
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };
    pagination(pageDetails);
  }, [pageIndex, pageSize, previousPage, nextPage]);

  return (
    <div
      className="container mx-auto float-left h-[100%]"
      style={{ maxWidth: "100%" }}
    >
      <div className="flex flex-col h-full items-center">
        {tabledata?.length === 0 && flag === false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <div className="overflow-x-auto scrollbar-thin w-full">
            {" "}
            {/* Add this wrapper for horizontal scrolling */}
            {/* {page.length === 0 ? (
              <Empty className=" mt-40" description={t("No data available")} />
            ) : ( */}
            <table
              {...getTableProps()}
              className="mt-7 font-normal ms-3 me-3 min-w-[800px] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto h-[100%] shadow-xl rounded-lg"
              // className="mt-7 font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] min-h-auto h-[100%] shadow-xl rounded-lg overflow-hidden"
              style={{
                direction: i18n.language === "ar" ? "rtl" : "ltr",
              }}
            >
              <thead>
                {headerGroups.map((headerGroup, headerIndex) => {
                  const { key: headerKey, ...headerGroupProps } =
                    headerGroup.getHeaderGroupProps();
                  return (
                    <tr
                      key={headerKey}
                      {...headerGroupProps}
                      className="bg-[#78CFEC66] text-sm font-semibold"
                    >
                      {headerGroup.headers.map((column, colIndex) => {
                        const { key: columnKey, ...columnProps } =
                          column.getHeaderProps(
                            column.getSortByToggleProps()
                          );
                        return (
                          <th
                            key={columnKey}
                            {...columnProps}
                            className={`py-3 px-4 whitespace-nowrap ${i18n.language === "ar"
                              ? "text-right"
                              : "text-left"
                              }`}
                          >
                            <div className="flex items-center justify-start">
                              {column.render("Header")}
                              <span>
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <img
                                      src={Vectorsorting}
                                      style={{ minHeight: 10, minWidth: 10 }}
                                      alt="NA"
                                    />
                                  ) : (
                                    <img
                                      className="rotate-180"
                                      src={Vectorsorting}
                                      style={{ minHeight: 10, minWidth: 10 }}
                                      alt="NA"
                                    />
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </th>
                        );
                      })}
                    </tr>
                  );
                })}
              </thead>
              <tbody
                {...getTableBodyProps()}
                className="bg-[#F7F9FD] text-left"
              >
                {page.map((row, rowIndex) => {
                  prepareRow(row);
                  const { key: rowKey, ...rowProps } = row.getRowProps();
                  return (
                    <React.Fragment key={rowKey}>
                      <tr
                        {...rowProps}
                        className="relative hover:bg-white transition duration-300 border-b border-gray-300 cursor-pointer"
                      // onClick={() =>
                      //   openOrderList(row.original.order_details.order_no)
                      // }
                      >
                        {row.cells.map((cell, cellIndex) => {
                          const { key: cellKey, ...cellProps } =
                            cell.getCellProps();
                          return (
                            <td
                              key={cellKey}
                              {...cellProps}
                              className={`p-3 px-4 text-[#272728] text-sm font-normal ${i18n.language === "ar"
                                ? "text-right"
                                : "text-left"
                                }`}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    </React.Fragment>
                  );
                })}
                {page?.length === 0 && (
                  <tr>
                    <td colSpan={columns.length}>
                      <Empty className="mt-16" description={t("No data available")} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* )} */}
          </div>
        )}
        {/* {page.length != 0 && ( */}
        <div className="w-full">
          <CustomPagination
            data={tabledata?.length}
            pageIndex={pageIndex}
            pageCount={page?.length}
            canPreviousPage={pageIndex !== 1}
            canNextPage={tabledata?.length >= 10}
            gotoPage={(page) => nextPage(page)}
            previousPage={() => setpageIndex(pageIndex - 1)}
            nextPage={() => setpageIndex(pageIndex + 1)}
            pageSize={pageSize}
            setPageSize={(pageSize) => setPageSize(pageSize)}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default TransactionSummaryTable;

